import React from "react";
import { ToastProvider } from "./components/common/Toast";
import { Web3Provider } from "./context/Web3Context";
import { TxProvider } from "./context/TxContext";
import Navbar from "./components/layout/Navbar";
import NetworkGuard from "./components/NetworkGuard";
import AuthedApp from "./components/layout/AppShell";

// Provider order:
//   ToastProvider -> notifications everywhere
//   Web3Provider  -> wallet/network state (event-driven, no reload)
//   TxProvider    -> global full-screen loader during transactions
// The phone-width .app-shell wraps the top bar + gated content.
export default function App() {
  return (
    <ToastProvider>
      <Web3Provider>
        <TxProvider>
          <div className="app-shell">
            <Navbar />
            <NetworkGuard>
              <AuthedApp />
            </NetworkGuard>
          </div>
        </TxProvider>
      </Web3Provider>
    </ToastProvider>
  );
}
